<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row">
      <LocationShiftTime @event-edittime="onChangeTime" ref="manageLocShiftTimeControl"></LocationShiftTime>
    </div>
    <div class=" row">
      <ManageShiftProcedure ref="manageLocShiftProcControl"></ManageShiftProcedure>
    </div>
  </div>
</template>

<script>
  import LocationShiftTime from '../shift/location-shifts-time.vue'
  import ManageShiftProcedure from '../shift/manage-shift-procedures.vue'
  export default {
    name: "location-shifts-edit",
    components: {
      LocationShiftTime,
      ManageShiftProcedure
    },
    props: {
      locationshiftId: {
        type: Number,
        default: -1
      },
      dayId: {
        type: Number,
        default: -1
      },
      siteShiftId: {
        type: Number,
        default: -1
      },
      locationId: {
        type: Number,
        default: -1
      },
      index: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {

      };
    },
    methods: {
      onOrderChange(arraydragids, arraydropids) {
        this.$refs.manageLocShiftProcControl.onOrderChange(arraydragids, arraydropids);
      },

      onChangeTime(subaction) {
        var isclose = false;
        if (subaction === 'delete') {
          isclose = true;
        }
        var obj = {
          tab: "LocationShiftAdmin", action: "refreshlocshift", isclose: isclose, subaction: subaction, day: this.dayId,
          shiftId: this.siteShiftId, index: this.index
        };
        var data = JSON.stringify(obj);
        vm.$root.$emit('refreshview', data);
      },
      async setProperties(locationshiftId, locId, day, siteShiftId, index) {
        try {
          this.locationId = locId;
          this.dayId = day;
          this.siteShiftId = siteShiftId;
          this.locationshiftId = locationshiftId;
          this.index = index;

          this.$refs.manageLocShiftTimeControl.locationshiftId = this.locationshiftId;
          this.$refs.manageLocShiftProcControl.loadShiftProcedures(this.locationId, this.dayId, this.siteShiftId);
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
    },
    watch: {

    },
    mounted() {
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/location-shift-edit.vue